import React from 'react';

import { useResponsiveController } from '../ContextState/useResponsiveController';
import { useContextSwitcherData } from '../ContextSwitcher/Context/useContextSwitcherData';
import { MobileKeyboardNavProvider } from '../MobileNavBar/Context/MobileKeyboardNavContext';
import { MobileNavBar } from '../MobileNavBar/MobileNavBar';
import { IContextSwitcherData, IContextSwitcherOptions } from '../types';

import { DesktopNavBar } from './DesktopNavBar';

interface IResponsiveNavBarProps {
  appName: string;
  showOfflineIndicator: boolean;
  menuOptions: any;
  contextSwitcherOptions: any;
  switchMenuOptions: any;
  favoritesOptions: Partial<{
    favorites: any;
    customHeaderErrorMessage: string;
    emptyFavoritesHeader: string;
    emptyFavoritesMessage: string;
  }>;
}

export const ResponsiveNavBar: React.FC<IResponsiveNavBarProps> = ({
  appName,
  showOfflineIndicator,
  favoritesOptions,
  menuOptions,
  contextSwitcherOptions,
  switchMenuOptions
}) => {
  const { favorites, customHeaderErrorMessage, emptyFavoritesHeader, emptyFavoritesMessage } = favoritesOptions;

  const { isMobileBreakpointWidth, condensedUtilityTray } = useResponsiveController();

  const contextSwitcherData = useContextSwitcherData(contextSwitcherOptions || ({} as IContextSwitcherOptions));
  // Check if all of the properties of contextSwitcherData are null or undefined
  // 'activeProductKey' is not included in the check because it is not asynchronously fetched.
  // 'disabled' is excluded because a disabled switcher has no entitlement data to display —
  // we want downstream components to treat it the same as the "no context switcher" case.
  const emptyContextSwitcherData =
    Object.values({ ...contextSwitcherData, activeProductKey: null, disabled: null, onEntitySelect: null }).filter(
      (value) => !!value
    ).length === 0;
  return (
    <MobileKeyboardNavProvider>
      {isMobileBreakpointWidth ? (
        <MobileNavBar
          appName={appName}
          contextSwitcherData={emptyContextSwitcherData ? undefined : (contextSwitcherData as IContextSwitcherData)}
          showOfflineIndicator={showOfflineIndicator}
          menuOptions={menuOptions}
          switchMenuOptions={switchMenuOptions}
          favorites={favorites}
        />
      ) : (
        <DesktopNavBar
          condensedUtilityTray={condensedUtilityTray}
          showOfflineIndicator={showOfflineIndicator}
          appName={appName}
          customHeaderErrorMessage={customHeaderErrorMessage}
          emptyFavoritesHeader={emptyFavoritesHeader}
          emptyFavoritesMessage={emptyFavoritesMessage}
          contextSwitcherData={emptyContextSwitcherData ? undefined : (contextSwitcherData as IContextSwitcherData)}
        />
      )}
    </MobileKeyboardNavProvider>
  );
};
